import { render, staticRenderFns } from "./CarPartEditComponent.vue?vue&type=template&id=e1631132"
import script from "./CarPartEditComponent.vue?vue&type=script&lang=js"
export * from "./CarPartEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports